<template>
  <div>
    <!-- head头部导航栏 -->
    <el-header class="headder">

      <!-- 左边的盒子 -->
      <div class="header-left">
        <!-- logo和title -->
        <a class="header_logo" href="javascript:;">
          <span class="logo">
            <img src="../../assets/image/Logo (3).png" alt="">
          </span>
          <span>
            贝游特教育
          </span>
        </a>
        <!-- 首页和常见问题 -->
        <div class="header_nav">
          <a href="javascript:;" @click="goHome" class="header_a_color">首页</a>
          <a href="javascript:;" class="active_color">常见问题</a>
        </div>
      </div>
      <!-- 右边的盒子未登录 -->
      <!-- <div class="header-right">
        <span>登录</span>
      </div> -->
      <!-- 右边的盒子已登录 -->

    </el-header>
    <div class="base-page-pc__container">

      <!-- 面包屑到含量 -->
      <el-breadcrumb separator="/" class="el_breadcrumb">
        <el-breadcrumb-item :to="{ path: '/Container/home' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>常见问题</el-breadcrumb-item>
      </el-breadcrumb>
      <!-- 导航栏盒子和右侧的内容盒子 -->
      <el-row :gutter="20" type="flex" justify="space-between">
        <!-- 左侧导航栏 -->
        <el-col :span="6" class="nav-box">
          <el-menu :default-active="activeMenu" @select="selectItems">
            <el-submenu index="1">
              <template slot="title">游戏相关</template>
              <el-menu-item index="1-1">账号注册无法进入游戏</el-menu-item>
              <el-menu-item index="1-2">官方联系方式</el-menu-item>
            </el-submenu>
          </el-menu>
        </el-col>
        <!-- 右侧的内容 -->
        <el-col :span="16" class="nav-text">
          <div class="nav-text-con" v-if="activeNav">
            <h1 class="h1-title">账号注册无法进入游戏</h1>
            <h4>一、首次注册帐号实名认证完无法进入游戏</h4>
            <div>
              如果是首次注册且实名，由于实名存在认证上面的延迟，可以在实名后退出游戏。重新登陆游戏后进入登陆界面等待5-8秒再点【进入游戏】按钮即可。
            </div>
            <h4>二、老玩家无法进入游戏</h4>
            <div>这可能是由于官方服务器宕机或者网络延迟造成的，可以多次尝试切换网络，如果服务器问题可稍作等待一般来说官方团队都会尽快进行修复</div>
            <h4>三、首次注册完重新登陆也无法进入游戏</h4>
            <div>这一般是由于该款游戏可能已经作下架处理导致的，游戏下架停运会导致新用户无法登陆，如遇到该问题可以换其它游戏或向官方提交留言</div>
          </div>
          <div class="nav-text-con" v-if="!activeNav">
            <h1 class="h1-title">官方联系方式</h1>
            <h4>官方玩家QQ群：599261488</h4>

          </div>
        </el-col>

      </el-row>

    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeNav: true,
      activeMenu: "1-1",
    };
  },
  created() {
    const index = this.$route;
    if (index.query.id == "1-1") {
      this.activeMenu = "1-1";
    } else if (index.query.id == "1-2") {
      this.activeMenu = "1-2";
      this.activeNav = false;
    }
  },
  methods: {
    goHome() {
      this.$router.push("/Container/home");
    },
    selectItems(i) {
      console.log(i);
      if (i == "1-1") {
        console.log(111);
        this.activeNav = true;
      } else if (i == "1-2") {
        console.log(2222);
        this.activeNav = false;
      }
    },
  },
};
</script>

<style>
@import url(question.css);
</style>


// WEBPACK FOOTER //
// src/views/question/question.vue